"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const useSelfLanguage_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelfLanguage"));
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const PhotoTextInput_1 = __importDefault(require("@opsbase/web-conversation-views/src/PhotoTextInput"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useResolvedImages_1 = __importDefault(require("@opsbase/web-image/useResolvedImages"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const DatePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker"));
const FlagPicker_1 = __importDefault(require("@opsbase/web-pickers/FlagPicker"));
const IssueTypePicker_1 = __importDefault(require("@opsbase/web-pickers/IssueTypePicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const consts_1 = require("../consts");
const makeMyClasses = () => ({
    label: {
        width: 80,
        textAlign: 'right',
        paddingTop: 6,
        paddingRight: 6,
    },
    submitButton: {
        backgroundColor: lib_palette_1.default.Transparent.main,
        color: lib_palette_1.default.BlackCoral.main,
        borderRadius: 22,
        minWidth: 44,
    },
    commentsPane: {
        backgroundColor: lib_palette_1.default.White.main,
        border: `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        borderRadius: 8,
        maxHeight: 100,
        overflow: 'scroll',
    },
});
const areStatesEqual = (s1, s2) => {
    return (s1 &&
        s2 &&
        s1.title === s2.title &&
        s1.type === s2.type &&
        s1.flag === s2.flag &&
        s1.comment === s2.comment &&
        s1.deadlineDate === s2.deadlineDate &&
        (0, isEqual_1.default)(s1.photos, s2.photos));
};
const IssueForm = ({ onChange, value, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const answerIssue = answer === null || answer === void 0 ? void 0 : answer.issue;
    const { language } = (0, useSelfLanguage_1.default)();
    const isAlt = language !== Language_1.default.ENGLISH;
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, {
        title: (_d = (_c = (_a = answerIssue === null || answerIssue === void 0 ? void 0 : answerIssue.title) !== null && _a !== void 0 ? _a : (isAlt ? (_b = rule.titleAlt) === null || _b === void 0 ? void 0 : _b[language] : rule.title)) !== null && _c !== void 0 ? _c : rule.title) !== null && _d !== void 0 ? _d : value === null || value === void 0 ? void 0 : value.title,
        flag: (_f = (_e = answerIssue === null || answerIssue === void 0 ? void 0 : answerIssue.flag) !== null && _e !== void 0 ? _e : rule.flag) !== null && _f !== void 0 ? _f : value === null || value === void 0 ? void 0 : value.flag,
        type: (_h = (_g = answerIssue === null || answerIssue === void 0 ? void 0 : answerIssue.type) !== null && _g !== void 0 ? _g : rule.type) !== null && _h !== void 0 ? _h : value === null || value === void 0 ? void 0 : value.type,
        comment: (_j = answerIssue === null || answerIssue === void 0 ? void 0 : answerIssue.comment) !== null && _j !== void 0 ? _j : '',
        deadlineDate: (_k = answerIssue === null || answerIssue === void 0 ? void 0 : answerIssue.deadlineDate) !== null && _k !== void 0 ? _k : (rule.hasDeadline
            ? (0, moment_timezone_1.default)().add(rule.deadlineInDays, 'days').toISOString()
            : undefined),
        photos: Array.isArray(answer === null || answer === void 0 ? void 0 : answer.photos) ? answer === null || answer === void 0 ? void 0 : answer.photos : (_l = answer === null || answer === void 0 ? void 0 : answer.photos) === null || _l === void 0 ? void 0 : _l.split(','),
    });
    const resolvedImages = (0, useResolvedImages_1.default)(answer === null || answer === void 0 ? void 0 : answer.photos);
    const allowOverrides = !rule.hasOwnProperty('allowOverrides') || rule.allowOverrides;
    const { mode } = (0, usePerform_1.default)();
    const disabled = mode === 'view';
    const myCss = (0, web_css_1.default)(makeMyClasses);
    (0, react_1.useEffect)(() => {
        const isValid = !allowOverrides || (!!state.title && !!state.type && !!state.flag);
        if (isValid && !areStatesEqual(state, answerIssue)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(state);
        }
    }, [allowOverrides, answerIssue, onChange, state]);
    const handleChangeTitle = (0, react_1.useCallback)(title => dispatch({ field: 'title', value: title }), []);
    const handleChangeType = (0, react_1.useCallback)(type => dispatch({ field: 'type', value: type }), []);
    const handleChangeFlag = (0, react_1.useCallback)(flag => dispatch({ field: 'flag', value: flag }), []);
    const handleChangeComment = (0, react_1.useCallback)(comment => dispatch({ field: 'comment', value: comment }), []);
    const handleChangePhotos = (0, react_1.useCallback)(newValue => {
        dispatch({ field: 'photos', value: newValue.map(v => v.fileName) });
    }, []);
    const handleChangeDeadlineDate = (0, react_1.useCallback)((newValue) => dispatch({ field: 'deadlineDate', value: newValue.toISOString() }), []);
    const { flag: defaultFlag, title: defaultTitle, type: defaultType } = value !== null && value !== void 0 ? value : {};
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e;
        if (!answerIssue)
            dispatch({
                newState: {
                    title: (_c = (_b = (isAlt ? (_a = rule.titleAlt) === null || _a === void 0 ? void 0 : _a[language] : rule.title)) !== null && _b !== void 0 ? _b : rule.title) !== null && _c !== void 0 ? _c : defaultTitle,
                    flag: (_d = rule.flag) !== null && _d !== void 0 ? _d : defaultFlag,
                    type: (_e = rule.type) !== null && _e !== void 0 ? _e : defaultType,
                    comment: '',
                    deadlineDate: rule.hasDeadline
                        ? (0, moment_timezone_1.default)().add(rule.deadlineInDays, 'days').toISOString()
                        : undefined,
                },
            });
    }, [answerIssue, defaultFlag, defaultTitle, defaultType, isAlt, language, rule]);
    const dDate = (0, react_1.useMemo)(() => (state.deadlineDate ? (0, moment_timezone_1.default)(state.deadlineDate) : null), [state.deadlineDate]);
    return (react_1.default.createElement(Vertical_1.default, { padding: true, gutter: true },
        react_1.default.createElement(Horizontal_1.default, { centered: true },
            react_1.default.createElement(Text_1.default, { variant: "h3", className: myCss.label }, lib_i18n_1.default.t('title')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { white: true, inputProps: { style: consts_1.performInputStyle }, disabled: disabled || !allowOverrides, noBorder: !allowOverrides, fullWidth: true, noMargin: true, value: state.title, onBlur: handleChangeTitle }))),
        react_1.default.createElement(Horizontal_1.default, { centered: true },
            react_1.default.createElement(Text_1.default, { variant: "h3", className: myCss.label }, lib_i18n_1.default.t('type')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(IssueTypePicker_1.default, { white: true, disabled: disabled || !allowOverrides, noMargin: true, noBorder: !allowOverrides, value: state.type, onChange: handleChangeType }))),
        react_1.default.createElement(Horizontal_1.default, { centered: true },
            react_1.default.createElement(Text_1.default, { variant: "h3", className: myCss.label }, lib_i18n_1.default.t('priority')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(FlagPicker_1.default, { white: true, disabled: disabled || !allowOverrides, noMargin: true, noBorder: !allowOverrides, value: state.flag, onChange: handleChangeFlag }))),
        react_1.default.createElement(Horizontal_1.default, { centered: true },
            react_1.default.createElement(Text_1.default, { variant: "h3", className: myCss.label }, lib_i18n_1.default.t('deadline')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(DatePicker_1.default, { white: true, noMargin: true, disabled: disabled || !allowOverrides, value: dDate, onChange: handleChangeDeadlineDate }))),
        react_1.default.createElement(Horizontal_1.default, { centered: true },
            react_1.default.createElement(Text_1.default, { variant: "h3", className: myCss.label }, lib_i18n_1.default.t('comments')),
            react_1.default.createElement(Pane_1.default, { grow: true, classes: { root: myCss.commentsPane } },
                react_1.default.createElement(PhotoTextInput_1.default, { placeholderText: lib_i18n_1.default.t('create-issue-comment-placeholder'), text: state.comment, onTextChange: handleChangeComment, multiline: true, images: resolvedImages, onImagesChange: handleChangePhotos, editable: !disabled, hideSubmitButton: true })))));
};
exports.default = IssueForm;
